import React from 'react';
import ContactInfo from '../../components/shared/ContactInfo'
import Contact from './contactPopup';
import classNames from  'classnames'

class Footer extends React.Component {
  constructor(props) {
    super(props)

    this.state={
      showModal: window.location.pathname.startsWith('/login'),
    }
    this.handleClose=this.handleClose.bind(this);
  }
  
  handleClose(){
    this.setState({
      showModal: false
    })
  }

  render () {
    const isLoginPage =window.location.pathname.startsWith('/login');
    const columnSize = (isLoginPage) ? 4 : 0;
    return (
  <footer>
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 no_pad">
         {!isLoginPage && <div className="col-lg-10 col-md-8 col-sm-8 col-xs-12 no_pad">
            <ContactInfo></ContactInfo>
          </div>}
          <div className={classNames(`col-lg-${columnSize+2}`, `col-md-${columnSize+2}`,`col-sm-${columnSize+2}`, `col-xs-${isLoginPage? 6 : 12}`, "text-right", "no_pad")}>
            Owner&apos;s Edge {'\u00a9'} {new Date().getFullYear()}&nbsp;
          </div>
          <div className={classNames("col-lg-2 col-md-4 col-sm-4 col-xs-12","no_pad",
          { "text-right": !isLoginPage},)}>
            <a href="https://www.argolimited.com/privacy" target="_blank" style={{textDecoration:"underline", marginLeft: '10px'}}>Privacy Notice</a> 
            <br></br>
            {!isLoginPage && <div>
              <span style={{marginLeft: '10px'}}>Use of this site is governed by </span><br></br>
            <a href='https://www.argolimited.com/terms-and-conditions/' style={{textDecoration:"underline"}}>Argo Group's Terms and Conditions.</a>
              </div>}
          </div>
          <button className={classNames("fa",{'fa-envelope':!this.state.showModal}, {'fa-times-circle':this.state.showModal},{"crossicon" : this.state.showModal}, "contact") }
          onClick={()=> {this.setState({showModal: true})}}>      
        </button>
        <Contact showModal ={this.state.showModal} handleClose={this.handleClose}/>
        </div>
      </div>
      {isLoginPage && 
      <div style={{textAlign:'center'}}>
        <span style={{marginLeft: '10px'}}>Use of this site is governed by </span>
            <a href='https://www.argolimited.com/terms-and-conditions/' style={{textDecoration:"underline"}}>Argo Group's Terms and Conditions.</a>
      </div>}
    </div>
    </footer> )
  }
}

export default Footer